import React from 'react';
import {ReactComponent as Bin} from '../assets/svgs/bin.svg';
import { useMst } from '../models/root';
import { observer } from "mobx-react-lite";

export const IdeasListing = observer(()=>{
   const {myIdeas}=useMst(); 
   
    return (
        <div class="w-full fixed overflow-scroll h-full">
            {myIdeas.ideas.map((item)=>
                <div id ={item.id} class="relative px-5 py-3">
                    <div class="relative">
                        {item.text}
                    </div>
                    <div class="relative w-full h-8 border-b-2 p-1">
                    <div class="float-right font-bold relative mx-4"><p >Edit</p></div>
                    <div class="relative pt-1 float-right mx-4"><Bin/></div>
                    </div>
                </div>
            )}
        </div>
    );
})